<div id="ankuendigungsPopup">
  <div id="ankuendigungsOptionen"><mat-icon mat-dialog-close>close</mat-icon></div>
  <div id="ankuendigungsContent" *ngIf="ankuendigungsContent" [innerHTML]="ankuendigungsContent | img | async"></div>
</div>
